const baseUrl = "/v1/NotificacoesDoUsuario";

const service = {
  methods: {
    $buscarNotificacoes(params) {
      return this.$api().get(`${baseUrl}`, params);
    },
    $visualizarNotificacao(id) {
      return this.$api().get(`${baseUrl}/${id}`);
    },
    $marcarNotificacaoComoLida(id) {
      return this.$api().patch(`${baseUrl}/${id}/MarcarComoLida`);
    },
    $excluirNotificacao(id) {
      return this.$api().delete(`${baseUrl}/${id}`);
    }
  }
}

export default service;